import { render, staticRenderFns } from "./japan.vue?vue&type=template&id=a19c582a&scoped=true&"
import script from "./japan.vue?vue&type=script&lang=js&"
export * from "./japan.vue?vue&type=script&lang=js&"
import style0 from "./japan.vue?vue&type=style&index=0&id=a19c582a&prod&lang=less&"
import style1 from "./japan.vue?vue&type=style&index=1&id=a19c582a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19c582a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonCookiePanel: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/common/cookiePanel.vue').default})
